module.exports = __webpack_public_path__ + "img/info_btn.6479043c.png";